export type DocumentType = "pdf" | "image" | "unsupported";

const IMAGE_EXTENSIONS = new Set(["jpg", "jpeg", "png", "webp", "gif", "bmp"]);

const getPathname = (url: string): string => {
  try {
    return new URL(url).pathname;
  } catch {
    return url.split("?")[0].split("#")[0];
  }
};

// A document can hold several uploaded files; the API joins their URLs with "$$$".
export const parseDocumentUrls = (value: string | null | undefined): string[] =>
  (value ?? "")
    .split("$$$")
    .map((url) => url.trim())
    .filter(Boolean);

export const getDocumentType = (url: string): DocumentType => {
  const path = getPathname(url).trim().toLowerCase();
  const extension = path.includes(".")
    ? path.slice(path.lastIndexOf(".") + 1)
    : "";

  if (extension === "pdf") return "pdf";
  if (IMAGE_EXTENSIONS.has(extension)) return "image";
  return "unsupported";
};
